import React from 'react';
import "../styles/global.css";
import instagram_logo from '../assets/instagram_logo.png';


function DownBar () {

    const private_ig_link = "https://www.instagram.com/private__private__private?igsh=NWN5dmhreGVzczlt"

    return (
        <div className='down-bar-container'>
            <a 
                href={private_ig_link} 
                target="_blank" 
                rel="noopener noreferrer"
            >
                <img 
                    src={instagram_logo} 
                    alt="Instagram"
                />
            </a>
        </div>
    );
};

export default DownBar;